import React, { useEffect } from "react";
import styles from "./AdsListAmination.module.css";
import lottie from "lottie-web";
import listAnimation from "../jsonFile/X4YQnjffiE.json";
const AdsListAnimation = () => {
  useEffect(() => {
    const container = document.querySelector("#container");
    lottie.loadAnimation({
      container: container,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: listAnimation,
    });
  }, []);
  return (
    <div className={styles.container}>
      <div id="container" style={{ width: "5vw" }}></div>
    </div>
  );
};

export default AdsListAnimation;
